export default __webpack_public_path__ + "static/char-46-anr-5e5725eebf54f30ba0e1c1275a3e5256.gif";